import { useState, useCallback } from 'react';

export function useInlineEdit({ onSave, onError, editableFields = ['keyword'] }) {
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [saving, setSaving] = useState(false);

  const startEdit = useCallback((row) => {
    setEditingRowId(row._id);
    const initial = {};
    editableFields.forEach((field) => { initial[field] = row[field] ?? null; });
    setEditedValues(initial);
  }, [editableFields]);

  const cancelEdit = useCallback(() => {
    setEditingRowId(null);
    setEditedValues({});
  }, []);

  const saveEdit = useCallback(async (rowId) => {
    try {
      setSaving(true);
      await onSave(rowId, editedValues);
      setEditingRowId(null);
      setEditedValues({});
      return true;
    } catch (err) {
      console.error('Error saving inline edit:', err);
      onError?.(err.message);
      return false;
    } finally {
      setSaving(false);
    }
  }, [editedValues, onSave, onError]);

  const updateField = useCallback((field, value) => {
    setEditedValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  return {
    editingRowId,
    editedValues,
    saving,
    startEdit,
    cancelEdit,
    saveEdit,
    updateField,
  };
}
